import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import useBulkUploadAccess from "../../app/hooks/useBulkUploadAccess";

const BulkUploadGate = ({ moduleProcess, children }) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const { canUpload, hasModulePermission, flowEngineEnabled, canBulkUpload, roleKey } =
    useBulkUploadAccess(moduleProcess);

  const matchToPre = String(configuration?.flowImportMatchToPreEnabled ?? "true").toLowerCase() === "true";
  const matchMode = String(configuration?.matchPreManagerToManagerData || "id").toLowerCase();

  if (canUpload) {
    const showManagerMatchHint = roleKey === "manager" && flowEngineEnabled;
    return (
      <>
        {showManagerMatchHint && (
          <div className="container pt-3">
            <div className={`alert ${matchToPre ? "alert-info" : "alert-secondary"} mb-0`}>
              {matchToPre
                ? (
                  <>
                    {t(
                      matchMode === "name"
                        ? "bulk-upload.match.hint-name"
                        : (matchMode === "id-name"
                          ? "bulk-upload.match.hint-id-name"
                          : "bulk-upload.match.hint-id"),
                      matchMode === "name"
                        ? "Asociación activa: cada fila debe existir por nombre en tu bandeja de Gestor (después de reclamarlo en Pool de DRI). Si el nombre no existe o no está en tu bandeja, la fila queda inválida."
                        : (matchMode === "id-name"
                          ? "Asociación activa: cada fila debe existir por id y nombre en tu bandeja de Gestor (después de reclamarlo en Pool de DRI). Si no hay coincidencia, la fila queda inválida."
                          : "Asociación activa: cada fila debe existir por id (columna 0.id) en tu bandeja de Gestor (después de reclamarlo en Pool de DRI). Si el id no existe o no está en tu bandeja, la fila queda inválida.")
                    )}
                    {" "}
                    {t(
                      "bulk-upload.match.hint-publish",
                      "Si flow_state es Publicado, la fila no tiene que estar en la bandeja: se crea el registro, el motor guarda la publicación y el caso queda publicado."
                    )}
                  </>
                )
                : t(
                  "bulk-upload.match.hint-create",
                  "Modo clásico: la carga crea registros nuevos. Si el código y el nombre ya existen, la fila queda inválida."
                )}
            </div>
          </div>
        )}
        {roleKey === "feeder" && (
          <div className="container pt-3">
            <div className="alert alert-info mb-0">
              {t(
                "bulk-upload.term.hint",
                "Como Alimentador importas la hoja term de este módulo. Un campo es obligatorio y el resto es opcional. CIIU y tramo se cargan con el código del último nivel. Si la columna is_inital_aligment_migration viene en true, se conserva el id de 0.id; si esa columna no está, el sistema asigna el id."
              )}
            </div>
          </div>
        )}
        {children}
      </>
    );
  }

  let reasonKey = "bulk-upload.denied.default";
  let reasonFallback = "No tienes permiso para cargar matrices en este módulo.";

  if (!hasModulePermission) {
    reasonKey = "bulk-upload.denied.module";
    reasonFallback = "Tu rol activo no tiene asignado este módulo en administración de roles.";
  } else if (flowEngineEnabled && roleKey !== "feeder" && !canBulkUpload) {
    reasonKey = "bulk-upload.denied.role";
    reasonFallback = "Con el motor de flujos activo, solo Gestor, Pre-Gestor o Alimentador pueden cargar matrices.";
  } else if (!flowEngineEnabled && roleKey !== "feeder") {
    reasonKey = "bulk-upload.denied.legacy-role";
    reasonFallback = "En modo legacy, la carga masiva corresponde al rol Especialista (Feeder).";
  }

  return (
    <div className="container py-4">
      <div className="alert alert-warning mb-0">
        <strong>{t("bulk-upload.denied.title", "Carga masiva no disponible")}</strong>
        <p className="mb-0 mt-2">{t(reasonKey, reasonFallback)}</p>
      </div>
    </div>
  );
};

BulkUploadGate.propTypes = {
  moduleProcess: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default BulkUploadGate;
